<div *ngIf="!(accessType==='None')">
<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput class="search-components textBox" type="text" placeholder="Search Elements here..."
          [(ngModel)]="str" (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true"
          (focusout)="searchFocus = false" autofocus />
      </div>
    </div>
    <div class="filterSection spImg">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <!-- <div class="searchfilter">
          <span [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0"
            (keydown)="callToggles($event, 'exact')">
            Exact & Latest
          </span>
        </div> -->
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>

  <div class="storyMobScroll">
    <div class="headingsList" *ngIf="!types || types !== 'chart'">
      <ul>
        <ng-container *ngFor="let header of headerList">
          <li [class]="header.class">{{header.name}}</li>
        </ng-container>
      </ul>
    </div>
    <div class="contentList">
      <ng-template #loading>
        <div style="text-align: center; display: inline-block; width: 100%;">
          <ng-container *ngIf="callFail">
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
              Sorry, Server Error
            </div>
          </ng-container>
          <ng-container *ngIf="!callFail">
            <div class="imagepreloader">
              <div class="a" style="--n: 5;">
                <div class="dot dot1" style="--i: 0;"></div>
                <div class="dot dot2" style="--i: 1;"></div>
                <div class="dot dot3" style="--i: 2;"></div>
                <div class="dot dot4" style="--i: 3;"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #nores>
        <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
      </ng-template>
      <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
      <ng-template #listData>
        <ng-container *ngIf="listArray.length > 0;else loading">
          <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
          <ng-container *ngIf="!types || types !== 'chart'">
            <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
              <div class='story_status'>
                <em #unlockDropdown [class]="getclassonCondition(item.lockedByUserId, item.metadata.status)">
                  <div class="arrow_box single" *ngIf="(item.lockedByUserId && unlockOptions !== i)">
                    {{item.lockedByUserName}}</div>
                </em>
              </div>
              <ul [class.active]="!item.lockedByUserId" class="listingul"  #listData2>
                <a #listEl tabindex="0" (click)="clickAction(item)">
                  <li class="name">
                    <small [title]="item.title">
                      <div class="relhidden">
                        <div  class="listCell">{{item.title | titlecase}}</div>
                      </div>
                    </small>
                  </li>
                  <li class="status" [title]="item.metadata.status">
                    <span [class]="item.metadata.status.toLowerCase()">
                      {{item.metadata.status}}
                    </span>
                  </li>
                  <li class="lastModifiedBy" [title]="item.lastModifiedByUserName">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.lastModifiedByUserName">{{item.lastModifiedByUserName | titlecase}}</div>
                    </div>
                  </li>
                  <li class="lastupdae">{{getNewTypeDate(item.lastModifiedDate)}}</li>
                  <li class="lastModifiedBy" [title]="item.type">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.type">{{item.type | titlecase}}</div>
                    </div>
                  </li>

                </a>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngIf="types && types.trim() === 'chart'">
            <div class="chartBlock" *ngIf="item.chart && item.chart.images && item.chart.images.original">
              <div class="image" (mouseenter)="onHovering(i)">
                
                  <img [src]="item.chart.images.original" alt="">
                  <span class="hover" *ngIf="hoveringIndex === i">
                    <button class="blue chartBtn" (click)="pickElementForStory(item.id)">Use Chart</button>
                  </span>
                
              </div>
            </div>
          </ng-container>

          </ng-container>
        </ng-container>
      </ng-template>
    </div>
  </div>
  





  <div class="footerPagination">
    <div class="pagination" *ngIf="totalRecords > 50">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div class="recordList">Showing
        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>
</div>
</div>
<div *ngIf="(accessType==='None')">
  <p>You do not have access.</p>
</div>